module.exports = __webpack_public_path__ + "static/img/404.380bb85c.svg";